import { useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import { useAdminProfile } from "../api/queries/useAdminProfile";

import { BasicInfoForm } from "./BasicInfoForm";

export function BasicInfoCard() {
  const [isEditing, setIsEditing] = useState(false);
  const { data: profileData } = useAdminProfile();

  if (!profileData) return null;

  return (
    <DashboardCard2
      Actions={
        !isEditing && (
          /** CSE account has no option to edit profile info
           * TODO: Adjust BasicInfoForm to reuse in Provider scope
           */
          <Button2 isDisabled onPress={() => setIsEditing(true)} size="sm" variant="link">
            Edit
          </Button2>
        )
      }
      title="Basic Information"
    >
      <BasicInfoForm
        isReadOnly={!isEditing}
        key={isEditing ? "edit" : "view"}
        onCancel={() => setIsEditing(false)}
        profileData={profileData}
      />
    </DashboardCard2>
  );
}
